import { Button, Form, Input, InputNumber } from "antd";
import { requiredField } from "../common/common";
import { useEffect, useState } from "react";
import axiosInstance from "../common/api";
import { useNavigate, useParams } from "react-router";

export default function () {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    setLoading(true);
    axiosInstance
      .get(`/courseType/${id}`)
      .then(({ data }) => form.setFieldsValue(data))
      .finally(() => setLoading(false));
  }, []);

  const onFinish = (data) => {
    setLoading(true);
    axiosInstance
      .put(`/courseType/${id}`, data)
      .then(() => navigate(-1))
      .finally(() => setLoading(false));
  };

  return (
    <Form form={form} onFinish={onFinish} layout="vertical" autoComplete="off">
      <Form.Item label="Nome" rules={[requiredField]} name="title">
        <Input />
      </Form.Item>
      <Form.Item label="Durata in anni" rules={[requiredField]} name="yearsDuration">
        <InputNumber controls={false} precision={0} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Conferma
        </Button>
      </Form.Item>
    </Form>
  );
}
